import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const deliveryChannelFields = `
id
channelUniqueId
channelName
`

export const CREATE_SERVICE_DELIVERY_CHANNEL = gql`
  mutation CreateServiceDeliveryChannelsMutation($input: ServiceDeliveryChannelsInputObjects!) {
    createServiceDeliveryChannelsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${deliveryChannelFields}
      }
    }
  }
`


export const GET_SERVICE_DELIVERY_CHANNELS = gql`
  query GetInstitutionServicesDeliveryChannels($serviceUniqueId: String) {
    getInstitutionServicesDeliveryChannels(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${deliveryChannelFields}
      }
    }
  }
`


export const DELETE_SERVICE_DELIVERY_CHANNELS = gql`
  mutation DeleteServiceDeliveryChannelsMutation($channelUniqueId: String) {
    deleteServiceDeliveryChannelsMutation(channelUniqueId: $channelUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

